import React from 'react'
import Card from '../layout/Card'

type Props = { imgSrc: string, title: string, color?: string }
const JobOfferBadge: React.FC<Props> = ({ imgSrc, title, color }) => {
  return (
    <Card className='border border-1 border-solid border-deep-green-200'>
      <div className='flex flex-row items-center gap-x-4'>
        <img src={imgSrc} alt={title} className='max-h-[70px] max-w-[120px] md:max-w-[160px] rounded-lg' />
        <div className={`content max-w-[330px] text-${color}`}><b>{title}</b></div>
      </div>
    </Card>
  )
}

export default JobOfferBadge
